export default [
  'en',
  'fr',
  'ja',
  'de',
  'ko',
  'es',
  'it',
  'pt',
  'zh',
  'zh-cn',
  'zh-tw',
  'tr',
  'id',
  'ru',
  'th',
  'gn',
  'he',
  'ar',
  'pl',
  'nl',
  'tl',
  'ro',
  'af',
  'uk',
  'el',
  'sv',
  'hu',
  'bg',
  'da',
  'hr',
  'vi',
];
